export interface AliasCustomisations {
    getDisplayAliasForAliasSet?(canonicalAlias: string | null, altAliases: string[]): string | null;
}

// A real customisation module will define and export one or more of the
// customisation points that make up `AliasCustomisations`.
export default {} as AliasCustomisations;
